import { useNavigate } from "react-router-dom";

import { pathGenerators } from "utils/routes";

import s from "./PatientDetailsButton.module.css";

const PatientDetailButton = ({ patientId, patientFullName }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(pathGenerators.patient.details(patientId));
  };

  return (
    <button className={s.button} onClick={handleClick}>
      {patientFullName}
    </button>
  );
};

export { PatientDetailButton };
